import { Typography } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/BookingPermissionTableRow'

type BookingPermissionTableRowSkeletonProps = {
  isOdd: boolean
}

const BookingPermissionTableRowSkeleton = ({
  isOdd
}: BookingPermissionTableRowSkeletonProps) => {
  const classes = useStyles()

  return (
    <div
      className={[
        classes.tableRow,
        isOdd && classes.tableRowOdd,
        classes.tableRowSkeleton
      ].join(' ')}>
      <div>
        <Typography variant="body1">
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          <Skeleton animation="wave" className={classes.skeleton} />
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          <Skeleton
            animation="wave"
            className={[classes.skeleton, classes.skeletonCheckBox].join(' ')}
          />
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          <Skeleton
            animation="wave"
            className={[classes.skeleton, classes.skeletonCheckBox].join(' ')}
          />
        </Typography>
      </div>
    </div>
  )
}

export default BookingPermissionTableRowSkeleton
